// extracted by mini-css-extract-plugin
export default {"summaryAndPaymentHeader":"summaryAndPaymentHeader_q4yQ8tvj","title__border":"title__border_daRhbMSl","title":"title_SozTe8BD"};